/**
 * Podcast Data
 *
 * This file contains the detailed data for each podcast episode.
 * It's imported by components that need to display podcast information.
 */

export const podcastData = [
    {
        id: 'podcast-1',
        title: 'Ghada Jurdi : National Team Management ',
        image: 'images/podcast/ghadajurdi.png',
        audioUrl: 'audio/mock-podcast.mp3', 
        videoUrl: 'https://www.youtube.com/embed/njfg2z96zDU?si=mDs-xeDclGkpxoU-',
        videoType: 'youtube', // Specify video source type
        duration: '45:18',
        releaseDate: 'March 1, 2026',
        views: 28345,
        description: 'A deep dive into the rapid growth of women\'s football worldwide. We discuss the commercial explosion, media rights, and the path to professionalization across different leagues. Featuring insights from industry experts and former players, this episode explores what the next decade holds for the beautiful game. The discussion also covers grassroots development and the challenges that still remain in achieving true parity.',
        ratings: { average: 4.8, count: 124 },
        comments: [
            { user: 'Alex', text: 'Fantastic analysis! The section on media rights was particularly insightful.' },
            { user: 'Sam', text: 'Great episode. Would love to hear more about the South American leagues next time.' }
        ],
        related: ['podcast-2', 'podcast-5']
    },
    {
        id: 'podcast-2',
        title: 'Linnea Lindmark : Agent, Five9 Sports        ',
        image: 'images/podcast/linnea.png',
        audioUrl: 'audio/mock-podcast.mp3',
        videoUrl: null, 
        videoType: null,
        duration: '55:30',
        releaseDate: 'February 22, 2026',
        views: 19870,
        description: 'A tactical breakdown comparing the prevailing styles of play in the Women\'s Super League and the National Women\'s Soccer League. Are the stereotypes of physical, transition-based play in the NWSL and technical, possession-based play in the WSL still accurate? We analyze key matches and player roles to find out.',
        ratings: { average: 4.9, count: 98 },
        comments: [
            { user: 'Casey', text: 'As a coach, this was incredibly useful. Thank you!' }
        ],
        related: ['podcast-1', 'podcast-3']
    },
    {
        id: 'podcast-3',
        title: 'Assile Toufaily : PhD | Football Research  ',
        image: 'images/podcast/assiletoufaily.png',
        audioUrl: 'audio/mock-podcast.mp3', 
        videoUrl: 'https://www.youtube.com/embed/njfg2z96zDU?si=mDs-xeDclGkpxoU-', // Placeholder
        videoType: 'youtube',
        duration: '38:50',
        releaseDate: 'February 15, 2026',
        views: 15234,
        description: 'This episode tells the inspiring story of a local club that went from a Sunday league team to a semi-professional powerhouse. We interview the founders, coaches, and players who made it happen, exploring the challenges of funding, facilities, and community-building.',
        ratings: { average: 4.7, count: 76 },
        comments: [],
        related: ['podcast-1', 'podcast-4']
    },
    {
        id: 'podcast-4',
        title: 'Lexis Nickal : Project Manager | Marketing Operations',
        image: 'images/podcast/lexis.png',
        audioUrl: 'audio/mock-podcast.mp3',
        videoUrl: null, 
        videoType: null,
        duration: '62:10',
        releaseDate: 'February 8, 2026',
        views: 21050,
        description: 'An in-depth interview with one of the league\'s rising stars. We talk about her journey to the top, the sacrifices she made, her training regimen, and her ambitions for the future with her club and country.',
        ratings: { average: 4.8, count: 112 },
        comments: [
            { user: 'Jamie', text: 'So inspiring!' }
        ],
        related: ['podcast-2', 'podcast-6']
    },
    {
        id: 'podcast-5',
        title: 'Jiahe Liu : International Sports Lawyer',
        image: 'images/podcast/jiahe.png',
        audioUrl: 'audio/mock-podcast.mp3', 
        videoUrl: 'https://www.youtube.com/embed/njfg2z96zDU?si=mDs-xeDclGkpxoU-', // Placeholder
        videoType: 'youtube',
        duration: '48:05',
        releaseDate: 'February 1, 2026',
        views: 18400,
        description: 'We pull back the curtain on the finances of women\'s football. Topics include sponsorship deals, player contracts, club profitability, and the role of agents. A must-listen for anyone interested in the commercial side of the sport.',
        ratings: { average: 4.6, count: 85 },
        comments: [
            { user: 'Taylor', text: 'Really opened my eyes to the complexities involved.' }
        ],
        related: ['podcast-1', 'podcast-6']
    },
    {
        id: 'podcast-6',
        title: 'Patricia Owomugisha : Sports Management',
        image: 'images/podcast/patricia.png',
        audioUrl: 'audio/mock-podcast.mp3',
        videoUrl: null, 
        videoType: null,
        duration: '58:20',
        releaseDate: 'January 25, 2026',
        views: 16900,
        description: 'Our weekly roundup of the biggest stories from women\'s football leagues around the world, including Liga F, Frauen-Bundesliga, Division 1 Féminine, and the A-League Women. We cover key results, standout performances, and transfer news.',
        ratings: { average: 4.7, count: 91 },
        comments: [],
        related: ['podcast-2', 'podcast-5']
    },
    {
        id: 'podcast-7',
        title: 'Lia Ehlers : Operations Management',
        image: 'images/podcast/lia.png',
        audioUrl: 'audio/mock-podcast.mp3',
        videoUrl: null, 
        videoType: null,
        duration: '58:20',
        releaseDate: 'January 25, 2026',
        views: 16900,
        description: 'Our weekly roundup of the biggest stories from women\'s football leagues around the world, including Liga F, Frauen-Bundesliga, Division 1 Féminine, and the A-League Women. We cover key results, standout performances, and transfer news.',
        ratings: { average: 4.7, count: 91 },
        comments: [],
        related: ['podcast-2', 'podcast-5']
    }
];

/**
 * Helper function to get podcast details by ID.
 * In a real app, this might be an API call.
 * @param {string} id The ID of the podcast to find.
 * @returns {object|undefined} The podcast data object or undefined if not found.
 */
export function getPodcastById(id) {
    return podcastData.find(p => p.id === id);
}

/**
 * Helper function to get multiple podcasts by their IDs.
 * @param {string[]} ids An array of podcast IDs.
 * @returns {object[]} An array of podcast data objects.
 */
export function getPodcastsByIds(ids) {
    return podcastData.filter(p => ids.includes(p.id));
}